import {commonData} from "./machine/commonData.js";

export const machineGuideData = {
  brands: [
    { id: 'all', name: '전체' },
    { id: 'common', name: '일반' },
    { id: 'newtack', name: '뉴텍' },
  ],
  guides: [
    ...commonData
  ]
};